module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/lacava.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/lacava.jpg
// module id = 611
// module chunks = 0